/**
 * This file was auto-generated, do not edit manually.
 *
 * Run `pnpm gen:routes` to re-generate this file.
 */

import { route, stringParser } from "typesafe-routes";

export const RouteIds = [
  "root",
  "auth",
  "authIndex",
  "authIframe",
  "authLayout",
  "authContinue",
  "authPasswordSetup",
  "authPasswordReset",
  "authPassword",
  "authMfaSetup",
  "authMfa",
  "authLoginSimple",
  "authLogin",
  "authLogout",
  "authNotFound",
  "protectedRoutes",
  "dashboard",
  "account",
  "accountProfile",
  "accountSecurity",
  "admin",
  "events",
  "eventsIndex",
  "eventsRefresh",
  "eventsRollback",
  "event",
  "eventDetailsTab",
  "eventCreateDataTab",
  "auditing",
  "auditingIndex",
  "fundFamilies",
  "fundFamilyList",
  "fundFamily",
  "fundFamilyIndex",
  "fundFamilyLayout",
  "fundFamilySummary",
  "capitalActivity",
  "capitalActivityIndex",
  "capitalActivityCapitalActivityEvent",
  "capitalActivityCapitalActivityEventIndex",
  "capitalActivityCapitalActivityEventNotices",
  "capitalActivityCapitalActivityEventCalls",
  "capitalActivityCapitalActivityEventAllocation",
  "capitalActivityCapitalCallEventOverview",
  "capitalActivityCapitalCallInvestorBreakdown",
  "capitalActivityCapitalActivityCallReallocation",
  "capitalActivityCapitalCallReallocationOverview",
  "capitalActivityCapitalActivityEventReallocationUpdate",
  "capitalActivityCapitalActivityEventReallocationReview",
  "capitalActivityCapitalActivityEventDistributions",
  "capitalActivityEventDistributions",
  "capitalActivityEventDistributionAllocation",
  "capitalActivityEventDistributionOverview",
  "distributionInvestorBreakdown",
  "capitalActivityCapitalActivityEventEqualization",
  "capitalActivityCapitalActivityEventEqualizationView",
  "capitalActivityCapitalActivityEventWaterfall",
  "capitalActivityCapitalActivityEventWaterfallReview",
  "capitalActivityCapitalActivityEventWaterfallReviewFundPreferredReturn",
  "capitalActivityCapitalActivityEventWaterfallReviewRoutes",
  "capitalActivityCapitalActivityEventWaterfallReviewFund",
  "capitalActivityCapitalActivityEventWaterfallReviewBreakdown",
  "capitalActivityCapitalActivityEventWaterfallReviewBreakdownInvestor",
  "capitalActivityCapitalActivityEventWaterfallReviewBreakdownInvestorPreferredReturn",
  "capitalActivityCapitalActivityEventWaterfallHybrid",
  "capitalActivityCapitalActivityEventWaterfallHybridInput",
  "capitalActivityCapitalActivityEventWaterfallHybridRequiredPaydownInput",
  "capitalActivityCapitalActivityEventWaterfallHybridAcceleratedPaydownInput",
  "capitalActivityCapitalActivityEventWaterfallHybridInputReview",
  "capitalActivityCapitalActivityEventWaterfallHybridExpenseAllocations",
  "fundFamilyCommitments",
  "fundFamilyCommitmentsIndex",
  "fundFamilyCommitmentsTab",
  "fundFamilyCommitmentsClosingsTab",
  "fundFamilyCommitmentsTransfersTab",
  "fundFamilyCommitmentsFee",
  "fundFamilyCommitmentsFeeOverride",
  "fundFamilyCommitmentsCommitment",
  "fundFamilyCommitmentsCommitmentActivity",
  "fundFamilyCommitmentsCommitmentProfile",
  "fundFamilyCommitmentsCommitmentFees",
  "fundFamilyCommitmentsCommitmentWaterfall",
  "fundFamilyCommitmentsCommitmentPerformance",
  "fundFamilyCommitmentsCancelCorrect",
  "fundFamilyCommitmentsCancelCorrectClass",
  "fundFamilyCommitmentsCancelCorrectFeeTrueUp",
  "fundFamilyCommitmentsCancelCorrectEqualization",
  "fundFamilyCommitmentsCancelCorrectHistorical",
  "fundFamilyCommitmentsInvestorEntities",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntity",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityTabActivity",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityTabProfile",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityTabCommitments",
  "fundFamilyCommitmentsInvestorEntitiesInvestorEntityTabPerformance",
  "fundFamilyCommitmentsInvestorEntitiesCommitments",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsFee",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsFeeOverride",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsCommitment",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsCommitmentActivity",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsCommitmentProfile",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsCommitmentFees",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsCommitmentWaterfall",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsCommitmentPerformance",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsCancelCorrect",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsCancelCorrectClass",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsCancelCorrectFeeTrueUp",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsCancelCorrectEqualization",
  "fundFamilyCommitmentsInvestorEntitiesCommitmentsCancelCorrectHistorical",
  "investorTransfers",
  "investorTransfersCreate",
  "investorTransfersSetup",
  "investorTransfersSetupDetails",
  "investorTransfersSetupTransferees",
  "investorTransfersSetupDocuments",
  "investorTransfersSetupReview",
  "investorTransfersSetupSetupFinalize",
  "investorTransfersView",
  "closing",
  "closingEdit",
  "closingCommitments",
  "closingCapitalEqualization",
  "closingNonCapitalEqualization",
  "closingFeeTrueUp",
  "closingReview",
  "closingCommitmentsTabReview",
  "closingCapitalEqualizationTabReview",
  "closingNonCapitalEqualizationTabReview",
  "closingFeeTrueUpTabReview",
  "closingView",
  "closingCommitmentsTabView",
  "closingCapitalEqualizationTabView",
  "closingNonCapitalEqualizationTabView",
  "closingFeeTrueUpTabView",
  "creditFacilities",
  "creditFacilitiesIndex",
  "creditFacilitiesCreditFacility",
  "creditFacilitiesCreditFacilityDashboard",
  "creditFacilitiesCreditFacilityPrincipal",
  "creditFacilitiesCreditFacilityExpenses",
  "creditFacilitiesCreditFacilityBorrowingBase",
  "creditFacilitiesCreditFacilitySetup",
  "creditFacilitiesCreditFacilitySetupDetails",
  "creditFacilitiesCreditFacilitySetupCommitments",
  "creditFacilitiesCreditFacilitySetupLoan",
  "creditFacilitiesCreditFacilitySetupBorrowingBase",
  "creditFacilitiesCreditFacilitySetupBorrowingBaseReview",
  "creditFacilitiesCreditFacilitySetupInvestorBorrowingBase",
  "creditFacilitiesCreditFacilityEvent",
  "creditFacilitiesCreditFacilityEventDrawdown",
  "creditFacilitiesCreditFacilityEventDrawdownUpdate",
  "creditFacilitiesCreditFacilityEventDrawdownReview",
  "creditFacilitiesCreditFacilityEventPaydownLegacy",
  "creditFacilitiesCreditFacilityEventPaydownUpdateLegacy",
  "creditFacilitiesCreditFacilityEventPaydownReviewLegacy",
  "creditFacilitiesCreditFacilityEventPaydown",
  "creditFacilitiesCreditFacilityEventPaydownUpdate",
  "creditFacilitiesCreditFacilityEventPaydownReview",
  "creditFacilitiesCreditFacilityEventReallocation",
  "creditFacilitiesCreditFacilityEventReallocationSelect",
  "creditFacilitiesCreditFacilityEventReallocationSplit",
  "creditFacilitiesCreditFacilityEventReallocationReview",
  "creditFacilitiesCreditFacilityEventMergeTranches",
  "creditFacilitiesCreditFacilityEventMergeTranche",
  "creditFacilitiesCreditFacilityEventMergeTrancheReview",
  "creditFacilitiesCreditFacilityExpenseEvent",
  "creditFacilitiesCreditFacilityExpenseEventSetup",
  "creditFacilitiesCreditFacilityExpenseEventBreakdown",
  "creditFacilitiesCreditFacilityExpenseEventReview",
  "fees",
  "feesIndex",
  "feesDashboard",
  "feePostingTab",
  "feeBasisTab",
  "feeOffsetsWaiverTab",
  "draftAllocations",
  "historicalAllocations",
  "feeChargeEventPosted",
  "feeChargeEventPostedBreakdown",
  "feeChargeEventPostedInvestor",
  "feeChargeEventPostedUse",
  "feeBreakdownManagementFeeCatchUp",
  "feeBreakdownCancelCorrectFeeAdjustments",
  "feeBreakdownHistoricalBasisFeeTrueUp",
  "feesPost",
  "feesPostReviewBasis",
  "feesPostReviewBasisHistoricalTrueUp",
  "feesPostReviewBasisBreakdown",
  "feesPostApplyOffsets",
  "feesPostApplyWaivers",
  "feesPostReviewFees",
  "lateOffsets",
  "lateOffsetsApplyOffsets",
  "lateOffsetsReviewFees",
  "fundFamilyConfiguration",
  "fundFamilyConfigurationIndex",
  "fundFamilyConfigurationCalculations",
  "fundFamilyConfigurationCalculationsIndex",
  "fundFamilyConfigurationCalculationsCreate",
  "fundFamilyConfigurationCalculationsEdit",
  "fundFamilyConfigurationTransactionCodes",
  "transactionCodesIndex",
  "transactionCodesEdit",
  "fundFamilyConfigurationClasses",
  "fundFamilyConfigurationClassesIndex",
  "fundFamilyConfigurationClassesEdit",
  "basic",
  "fundFamilyConfigurationClassesEditFees",
  "fundFamilyConfigurationClassesEditWaterfall",
  "fundFamilyConfigurationClassesEditCommitments",
  "fundFamilyConfigurationClassesFee",
  "fundFamilyConfigurationClassesFeeOverride",
  "fundFamilyConfigurationFund",
  "fundFamilyConfigurationFundIndex",
  "fundFamilyConfigurationFundBasic",
  "fundFamilyConfigurationFundDates",
  "fundFamilyConfigurationFundFeesList",
  "fundFamilyConfigurationFundWaterfall",
  "fundFamilyConfigurationFundClasses",
  "fundFamilyConfigurationFundFees",
  "fundFamilyConfigurationFundFeesAdd",
  "fundFamilyConfigurationFundFeesView",
  "fundFamilyConfigurationFundFeesEdit",
  "basisEdit",
  "classesEdit",
  "classesEditBasic",
  "classesEditFees",
  "classesEditWaterfall",
  "classesEditCommitments",
  "classesFee",
  "classesFeeOverride",
  "fundFamilyConfigurationFundStructure",
  "fundFamilyFundStructureSetupIndex",
  "allocations",
  "fundFamilyConfigurationAllocationRuleGraphCreate",
  "fundFamilyConfigurationAllocationRuleGraphAndUse",
  "rule-graph-and-use-details",
  "basis",
  "fundFamilyConfigurationAllocationRuleGraph",
  "rule-graph-details",
  "rule-graph-basis",
  "fundFamilyConfigurationEntities",
  "fundFamilyConfigurationEntitiesIndex",
  "fundFamilyConfigurationEntitiesList",
  "fundFamilyConfigurationEntitiesEntity",
  "fundFamilyConfigurationEntitiesEditPage",
  "fundFamilyConfigurationEntitiesEntityDetails",
  "create-entity",
  "fundFamilyConfigurationNotices",
  "setupNotices",
  "setupNoticesSchema",
  "setupNoticesConfig",
  "setupNoticesCapitalCall",
  "setupNoticesDistribution",
  "fundFamilyConfigurationCreditFacilities",
  "fundFamilyConfigurationCreditFacilitiesIndex",
  "fundFamilyConfigurationCreditFacilitiesCreditFacility",
  "fundFamilyConfigurationCreditFacilitiesCreditFacilityDetails",
  "fundFamilyConfigurationCreditFacilitiesCreditFacilityLoan",
  "fundFamilyConfigurationCreditFacilitiesCreditFacilitySettingsBorrowingBase",
  "fundFamilyConfigurationCreditFacilitiesCreditFacilitySettingsBorrowingBaseEdit",
  "fundFamilyConfigurationCreditFacilitiesCreditFacilityLoanVersionPage",
  "fundFamilyConfigurationCreditFacilitiesCreditFacilityLoanCreate",
  "fundFamilyConfigurationInvestorEntities",
  "fundFamilyConfigurationInvestorEntitiesInvestorEntity",
  "fundFamilyConfigurationInvestorEntitiesInvestorEntityTabActivity",
  "fundFamilyConfigurationInvestorEntitiesInvestorEntityTabProfile",
  "fundFamilyConfigurationInvestorEntitiesInvestorEntityTabCommitments",
  "fundFamilyConfigurationInvestorEntitiesInvestorEntityTabPerformance",
  "fundFamilyConfigurationInvestorEntitiesCommitments",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsFee",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsFeeOverride",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsCommitment",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsCommitmentActivity",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsCommitmentProfile",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsCommitmentFees",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsCommitmentWaterfall",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsCommitmentPerformance",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsCancelCorrect",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsCancelCorrectClass",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsCancelCorrectFeeTrueUp",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsCancelCorrectEqualization",
  "fundFamilyConfigurationInvestorEntitiesCommitmentsCancelCorrectHistorical",
  "fundFamilySetup",
  "fundFamilySetupIndex",
  "fundFamilySetupProfile",
  "fundFamilySetupDates",
  "fundFamilySetupEntities",
  "fundFamilySetupTransactions",
  "fundFamilySetupCalculations",
  "fundFamilySetupClasses",
  "fundFamilySetupFees",
  "fundFamilySetupFeesIndex",
  "fundFamilySetupFeesConfiguration",
  "fundFamilySetupFeesCreate",
  "fundFamilySetupFeesEdit",
  "fundFamilySetupWaterfalls",
  "fundFamilyInvestments",
  "investmentIndex",
  "investment",
  "investmentActivity",
  "investmentSetupProfile",
  "fundFamilyInvestmentsCreate",
  "portfolios",
  "portfolio",
  "portfolioActivity",
  "portfolioProfile",
  "portfolioInvestments",
  "financial-reporting",
  "index",
  "hypoCreate",
  "hypoCreateWorkflow",
  "input",
  "designateProtectedCarry",
  "review",
  "hypoWaterfallEdit",
  "hypotheticalWaterfall",
  "irr",
  "pref-breakdown",
  "investor-pref-breakdown",
  "hypotheticalWaterfallDesignateProtectedCarry",
  "hypotheticalWaterfallReview",
  "investorNav",
  "waterfallDetails",
  "performance",
  "fundFamilyNotFound",
  "general-ledger",
  "GLIntegrationList",
  "GLIntegration",
  "GLIntegrationIndex",
  "GLIntegrationView",
  "GLIntegrationProfile",
  "GLIntegrationEntries",
  "reports",
  "availableReportsList",
  "settings",
  "users",
  "entities",
  "entitiesList",
  "entitiesBulkAddBanks",
  "entitiesBulkAddContacts",
  "entitiesEntity",
  "entitiesEntityDetails",
  "transactions",
  "transactionsTableDraft",
  "transactionsTableDetails",
  "investorEntities",
  "investorEntitiesInvestorEntity",
  "investorEntitiesInvestorEntityTabActivity",
  "investorEntitiesInvestorEntityTabProfile",
  "investorEntitiesInvestorEntityTabCommitments",
  "investorEntitiesInvestorEntityTabPerformance",
  "investorEntitiesCommitments",
  "investorEntitiesCommitmentsFee",
  "investorEntitiesCommitmentsFeeOverride",
  "investorEntitiesCommitmentsCommitment",
  "investorEntitiesCommitmentsCommitmentActivity",
  "investorEntitiesCommitmentsCommitmentProfile",
  "investorEntitiesCommitmentsCommitmentFees",
  "investorEntitiesCommitmentsCommitmentWaterfall",
  "investorEntitiesCommitmentsCommitmentPerformance",
  "investorEntitiesCommitmentsCancelCorrect",
  "investorEntitiesCommitmentsCancelCorrectClass",
  "investorEntitiesCommitmentsCancelCorrectFeeTrueUp",
  "investorEntitiesCommitmentsCancelCorrectEqualization",
  "investorEntitiesCommitmentsCancelCorrectHistorical",
  "internal",
  "internalAuditing",
  "featureFlags",
  "featureFlag",
  "featureFlagDetails",
  "featureFlagEdit",
  "provisioning",
  "provisioningIndex",
  "customersTab",
  "usersTab",
  "shadowTab",
  "customer",
  "shadowDataRun",
  "eventing",
  "eventingIndex",
  "templateImportTab",
  "templateLoadTab",
  "templateExportTab",
  "eventTemplate",
  "template",
  "templateExport",
  "exportTemplateTab",
  "exportEventsTab",
  "templateLoad",
  "templateEvent",
  "templateExportRecord",
  "integrationTesting",
  "integrationTestingIndex",
  "activity",
  "configurations",
  "integrationTestingReport",
  "reportStats",
  "reportTransactions",
  "reportAPI",
  "reportEventing",
  "reportAllTests",
  "reportChanges",
  "reportIssues",
  "reportCustomers",
  "reportDebuggingGuide",
  "integrationTestingReportUpdate",
  "integrationTestingIndividualReport",
  "configuration",
  "investors",
  "investorsIndex",
  "investorsInvestor",
  "investorsInvestorIndex",
  "investorsInvestorView",
  "investorsInvestorActivity",
  "investorsInvestorProfile",
  "investorsInvestorFunds",
  "investorsInvestorPerformance",
  "investorsInvestorEntitiesList",
  "investorsInvestorEntities",
  "investorsInvestorEntitiesInvestorEntity",
  "investorsInvestorEntitiesInvestorEntityTabActivity",
  "investorsInvestorEntitiesInvestorEntityTabProfile",
  "investorsInvestorEntitiesInvestorEntityTabCommitments",
  "investorsInvestorEntitiesInvestorEntityTabPerformance",
  "investorsInvestorEntitiesCommitments",
  "investorsInvestorEntitiesCommitmentsFee",
  "investorsInvestorEntitiesCommitmentsFeeOverride",
  "investorsInvestorEntitiesCommitmentsCommitment",
  "investorsInvestorEntitiesCommitmentsCommitmentActivity",
  "investorsInvestorEntitiesCommitmentsCommitmentProfile",
  "investorsInvestorEntitiesCommitmentsCommitmentFees",
  "investorsInvestorEntitiesCommitmentsCommitmentWaterfall",
  "investorsInvestorEntitiesCommitmentsCommitmentPerformance",
  "investorsInvestorEntitiesCommitmentsCancelCorrect",
  "investorsInvestorEntitiesCommitmentsCancelCorrectClass",
  "investorsInvestorEntitiesCommitmentsCancelCorrectFeeTrueUp",
  "investorsInvestorEntitiesCommitmentsCancelCorrectEqualization",
  "investorsInvestorEntitiesCommitmentsCancelCorrectHistorical",
  "protectedNotFound",
  "notFound",
] as const;
export type RouteId = (typeof RouteIds)[number];
export const rootRoute = route(
  "/",
  {},
  {
    auth: route(
      "auth",
      {},
      {
        index: route("", {}, {}),
        iframe: route("iframe", {}, {}),
        continue: route("continue", {}, {}),
        passwordSetup: route("password/setup", {}, {}),
        passwordReset: route("password/reset", {}, {}),
        password: route("password", {}, {}),
        mfaSetup: route("mfa/setup", {}, {}),
        mfa: route("mfa", {}, {}),
        loginSimple: route("login/simple", {}, {}),
        login: route("login", {}, {}),
        logout: route("logout", {}, {}),
        notFound: route("", {}, {}),
      },
    ),
    dashboard: route("/", {}, {}),
    account: route(
      "account",
      {},
      {
        profile: route("", {}, {}),
        security: route("security", {}, {}),
      },
    ),
    admin: route(
      "admin",
      {},
      {
        events: route(
          "events",
          {},
          {
            index: route(
              "&:fundFamilyId",
              {
                fundFamilyId: stringParser,
              },
              {},
            ),
            refresh: route(
              "refresh&:fundFamilyId",
              {
                fundFamilyId: stringParser,
              },
              {},
            ),
            rollback: route(
              "rollback&:fundFamilyId",
              {
                fundFamilyId: stringParser,
              },
              {},
            ),
            event: route(
              ":customerEventId",
              {
                customerEventId: stringParser,
              },
              {
                detailsTab: route("", {}, {}),
                createDataTab: route("create-data", {}, {}),
              },
            ),
          },
        ),
      },
    ),
    auditing: route(
      "auditing",
      {},
      {
        index: route("", {}, {}),
      },
    ),
    fundFamilies: route(
      "fund-family",
      {},
      {
        fundFamilyList: route("", {}, {}),
        fundFamily: route(
          ":fundFamilyId",
          {
            fundFamilyId: stringParser,
          },
          {
            index: route("", {}, {}),
            summary: route("summary", {}, {}),
            capitalActivity: route(
              "capital-activity",
              {},
              {
                index: route("", {}, {}),
                capitalActivityEvent: route(
                  ":fundFamilyEventId",
                  {
                    fundFamilyEventId: stringParser,
                  },
                  {
                    index: route("", {}, {}),
                    notices: route("notices", {}, {}),
                    calls: route(
                      "calls",
                      {},
                      {
                        capitalActivityCapitalActivityEventAllocation: route(
                          "",
                          {},
                          {},
                        ),
                        capitalActivityCapitalCallEventOverview: route(
                          "capital-call-overview",
                          {},
                          {},
                        ),
                        capitalActivityCapitalCallInvestorBreakdown: route(
                          "capital-call-investor-breakdown",
                          {},
                          {},
                        ),
                        capitalActivityCapitalActivityCallReallocation: route(
                          "reallocation/:reallocationFundFamilyEventId",
                          {
                            reallocationFundFamilyEventId: stringParser,
                          },
                          {
                            capitalActivityCapitalCallReallocationOverview:
                              route(
                                "capital-call-reallocation-overview",
                                {},
                                {},
                              ),
                            capitalActivityCapitalActivityEventReallocationUpdate:
                              route("", {}, {}),
                            capitalActivityCapitalActivityEventReallocationReview:
                              route("review", {}, {}),
                          },
                        ),
                      },
                    ),
                    distributions: route(
                      "distribution",
                      {},
                      {
                        capitalActivityEventDistributions: route(
                          "distributions",
                          {},
                          {
                            capitalActivityEventDistributionAllocation: route(
                              "",
                              {},
                              {},
                            ),
                            capitalActivityEventDistributionOverview: route(
                              "overview",
                              {},
                              {},
                            ),
                            distributionInvestorBreakdown: route(
                              "distribution-investor-breakdown",
                              {},
                              {},
                            ),
                          },
                        ),
                      },
                    ),
                    equalization: route(
                      "equalization",
                      {},
                      {
                        view: route(
                          ":fundFamilySubEventId",
                          {
                            fundFamilySubEventId: stringParser,
                          },
                          {},
                        ),
                      },
                    ),
                    waterfall: route(
                      "waterfall",
                      {},
                      {
                        review: route(
                          "review/:fundFamilySubEventId",
                          {
                            fundFamilySubEventId: stringParser,
                          },
                          {
                            fundPreferredReturn: route(
                              "fund-preferred-return/:fundEntityId",
                              {
                                fundEntityId: stringParser,
                              },
                              {},
                            ),
                            routes: route("", {}, {}),
                            fund: route(
                              "fund-level/:fundEntityId",
                              {
                                fundEntityId: stringParser,
                              },
                              {},
                            ),
                            breakdown: route(
                              "breakdown/:fundEntityId/investor-entity/:investorEntityId",
                              {
                                fundEntityId: stringParser,
                                investorEntityId: stringParser,
                              },
                              {
                                investor: route("", {}, {}),
                                investorPreferredReturn: route(
                                  "investor-preferred-return",
                                  {},
                                  {},
                                ),
                              },
                            ),
                          },
                        ),
                        hybrid: route(
                          "hybrid/:fundFamilySubEventId",
                          {
                            fundFamilySubEventId: stringParser,
                          },
                          {
                            input: route(
                              "input",
                              {},
                              {
                                capitalActivityCapitalActivityEventWaterfallHybridRequiredPaydownInput:
                                  route("required-paydown", {}, {}),
                                capitalActivityCapitalActivityEventWaterfallHybridAcceleratedPaydownInput:
                                  route("accelerated-paydown", {}, {}),
                              },
                            ),
                            inputReview: route("review-inputs", {}, {}),
                            expenseAllocations: route(
                              "expense-allocations",
                              {},
                              {},
                            ),
                          },
                        ),
                      },
                    ),
                  },
                ),
              },
            ),
            commitments: route(
              "commitments",
              {},
              {
                tab: route("", {}, {}),
                closingsTab: route("closings", {}, {}),
                transfersTab: route("transfers", {}, {}),
                fee: route(
                  ":commitmentId/fees/:feeId",
                  {
                    commitmentId: stringParser,
                    feeId: stringParser,
                  },
                  {},
                ),
                feeOverride: route(
                  ":commitmentId/fees/:feeId/override",
                  {
                    commitmentId: stringParser,
                    feeId: stringParser,
                  },
                  {},
                ),
                commitment: route(
                  ":commitmentId",
                  {
                    commitmentId: stringParser,
                  },
                  {
                    activity: route("activity", {}, {}),
                    profile: route("profile", {}, {}),
                    fees: route("fees", {}, {}),
                    waterfall: route("waterfall", {}, {}),
                    performance: route("performance", {}, {}),
                  },
                ),
                cancelCorrect: route(
                  "cancel-correct/:commitmentId/:fundFamilyEventId",
                  {
                    commitmentId: stringParser,
                    fundFamilyEventId: stringParser,
                  },
                  {
                    class: route("", {}, {}),
                    feeTrueUp: route("fee-true-up", {}, {}),
                    equalization: route("equalization", {}, {}),
                  },
                ),
                cancelCorrectHistorical: route(
                  "cancel-correct/:commitmentId/:fundFamilyEventId/historical",
                  {
                    commitmentId: stringParser,
                    fundFamilyEventId: stringParser,
                  },
                  {},
                ),
                investorEntities: route(
                  "investor-entities",
                  {},
                  {
                    investorEntity: route(
                      ":investorEntityId",
                      {
                        investorEntityId: stringParser,
                      },
                      {
                        tabActivity: route("activity", {}, {}),
                        tabProfile: route("profile", {}, {}),
                        tabCommitments: route("commitments", {}, {}),
                        tabPerformance: route("performance", {}, {}),
                      },
                    ),
                    commitments: route(
                      ":investorEntityId/commitments",
                      {
                        investorEntityId: stringParser,
                      },
                      {
                        fee: route(
                          ":commitmentId/fees/:feeId",
                          {
                            commitmentId: stringParser,
                            feeId: stringParser,
                          },
                          {},
                        ),
                        feeOverride: route(
                          ":commitmentId/fees/:feeId/override",
                          {
                            commitmentId: stringParser,
                            feeId: stringParser,
                          },
                          {},
                        ),
                        commitment: route(
                          ":commitmentId",
                          {
                            commitmentId: stringParser,
                          },
                          {
                            activity: route("activity", {}, {}),
                            profile: route("profile", {}, {}),
                            fees: route("fees", {}, {}),
                            waterfall: route("waterfall", {}, {}),
                            performance: route("performance", {}, {}),
                          },
                        ),
                        cancelCorrect: route(
                          "cancel-correct/:commitmentId/:fundFamilyEventId",
                          {
                            commitmentId: stringParser,
                            fundFamilyEventId: stringParser,
                          },
                          {
                            class: route("", {}, {}),
                            feeTrueUp: route("fee-true-up", {}, {}),
                            equalization: route("equalization", {}, {}),
                          },
                        ),
                        cancelCorrectHistorical: route(
                          "cancel-correct/:commitmentId/:fundFamilyEventId/historical",
                          {
                            commitmentId: stringParser,
                            fundFamilyEventId: stringParser,
                          },
                          {},
                        ),
                      },
                    ),
                  },
                ),
              },
            ),
            investorTransfers: route(
              "investor-transfers",
              {},
              {
                create: route("create", {}, {}),
                setup: route(
                  "setup/:investorTransferId",
                  {
                    investorTransferId: stringParser,
                  },
                  {
                    details: route("", {}, {}),
                    transferees: route("transferees", {}, {}),
                    documents: route("documents", {}, {}),
                    review: route("review", {}, {}),
                    setupFinalize: route("finalize", {}, {}),
                  },
                ),
                view: route(
                  ":investorTransferId",
                  {
                    investorTransferId: stringParser,
                  },
                  {},
                ),
              },
            ),
            closing: route(
              "closing",
              {},
              {
                edit: route(
                  ":closingId/edit",
                  {
                    closingId: stringParser,
                  },
                  {
                    closingCommitments: route("", {}, {}),
                    closingCapitalEqualization: route(
                      "capitalEqualization",
                      {},
                      {},
                    ),
                    closingNonCapitalEqualization: route(
                      "nonCapitalEqualization",
                      {},
                      {},
                    ),
                    closingFeeTrueUp: route("feeTrueUp", {}, {}),
                    closingReview: route(
                      "review",
                      {},
                      {
                        closingCommitmentsTabReview: route("", {}, {}),
                        closingCapitalEqualizationTabReview: route(
                          "closingCapitalEqualizationTab",
                          {},
                          {},
                        ),
                        closingNonCapitalEqualizationTabReview: route(
                          "ClosingNonCapitalEqualizationsTab",
                          {},
                          {},
                        ),
                        closingFeeTrueUpTabReview: route(
                          "feeTrueUpTab",
                          {},
                          {},
                        ),
                      },
                    ),
                  },
                ),
                view: route(
                  ":closingId/view",
                  {
                    closingId: stringParser,
                  },
                  {
                    closingCommitmentsTabView: route("", {}, {}),
                    closingCapitalEqualizationTabView: route(
                      "closingCapitalEqualizationTab",
                      {},
                      {},
                    ),
                    closingNonCapitalEqualizationTabView: route(
                      "ClosingNonCapitalEqualizationsTab",
                      {},
                      {},
                    ),
                    closingFeeTrueUpTabView: route("feeTrueUpTab", {}, {}),
                  },
                ),
              },
            ),
            creditFacilities: route(
              "credit-facility",
              {},
              {
                index: route("", {}, {}),
                creditFacility: route(
                  ":creditFacilityId",
                  {
                    creditFacilityId: stringParser,
                  },
                  {
                    principal: route("principal", {}, {}),
                    expenses: route("expenses", {}, {}),
                    borrowingBase: route("borrowing-base", {}, {}),
                    setup: route(
                      "setup",
                      {},
                      {
                        details: route("", {}, {}),
                        commitments: route("commitments", {}, {}),
                        loan: route("loan", {}, {}),
                        borrowingBase: route("borrowing-base", {}, {}),
                        borrowingBaseReview: route("review", {}, {}),
                      },
                    ),
                    setupInvestorBorrowingBase: route(
                      "setup/borrowing-base/:borrowingBaseGroupId/investors",
                      {
                        borrowingBaseGroupId: stringParser,
                      },
                      {},
                    ),
                    event: route(
                      ":fundFamilyEventId",
                      {
                        fundFamilyEventId: stringParser,
                      },
                      {
                        drawdown: route(
                          "drawdown",
                          {},
                          {
                            update: route("", {}, {}),
                            review: route("review", {}, {}),
                          },
                        ),
                        paydownLegacy: route(
                          "legacy-paydown",
                          {},
                          {
                            creditFacilitiesCreditFacilityEventPaydownUpdateLegacy:
                              route("", {}, {}),
                            creditFacilitiesCreditFacilityEventPaydownReviewLegacy:
                              route("review", {}, {}),
                          },
                        ),
                        paydown: route(
                          "paydown",
                          {},
                          {
                            update: route("", {}, {}),
                            review: route("review", {}, {}),
                          },
                        ),
                        reallocation: route(
                          "reallocation",
                          {},
                          {
                            select: route("", {}, {}),
                            split: route("split", {}, {}),
                            review: route("review", {}, {}),
                          },
                        ),
                        mergeTranches: route(
                          "merge-tranche",
                          {},
                          {
                            creditFacilitiesCreditFacilityEventMergeTranche:
                              route("", {}, {}),
                            creditFacilitiesCreditFacilityEventMergeTrancheReview:
                              route("review", {}, {}),
                          },
                        ),
                      },
                    ),
                    expenseEvent: route(
                      ":expenseEventId/expenses",
                      {
                        expenseEventId: stringParser,
                      },
                      {
                        setup: route("", {}, {}),
                        breakdown: route("breakdown", {}, {}),
                        review: route("review", {}, {}),
                      },
                    ),
                  },
                ),
              },
            ),
            fees: route(
              "fees",
              {},
              {
                index: route("", {}, {}),
                dashboard: route(
                  "dashboard",
                  {},
                  {
                    feePostingTab: route("postings", {}, {}),
                    feeBasisTab: route("basis", {}, {}),
                    feeOffsetsWaiverTab: route("offsets-waivers", {}, {}),
                  },
                ),
                draftAllocations: route("draftAllocations", {}, {}),
                historicalAllocations: route(
                  ":fundFamilyEventId/historicalAllocations",
                  {
                    fundFamilyEventId: stringParser,
                  },
                  {},
                ),
                feeChargeEventPosted: route(
                  ":feeChargeEventId/posted",
                  {
                    feeChargeEventId: stringParser,
                  },
                  {
                    breakdown: route("", {}, {}),
                    investor: route("by-investor", {}, {}),
                    use: route("by-use", {}, {}),
                  },
                ),
                feeBreakdownManagementFeeCatchUp: route(
                  ":feeChargeEventId/posted/catch-up",
                  {
                    feeChargeEventId: stringParser,
                  },
                  {},
                ),
                feeBreakdownCancelCorrectFeeAdjustments: route(
                  ":feeChargeEventId/posted/cancel-correct-fee-adjustments",
                  {
                    feeChargeEventId: stringParser,
                  },
                  {},
                ),
                feeBreakdownHistoricalBasisFeeTrueUp: route(
                  ":feeChargeEventId/posted/historical-basis-true-up",
                  {
                    feeChargeEventId: stringParser,
                  },
                  {},
                ),
                post: route(
                  "post/:feeChargeEventId",
                  {
                    feeChargeEventId: stringParser,
                  },
                  {
                    reviewBasis: route(
                      "basis",
                      {},
                      {
                        historicalTrueUp: route("historical", {}, {}),
                        breakdown: route("investor", {}, {}),
                      },
                    ),
                    applyOffsets: route("offsets", {}, {}),
                    applyWaivers: route("waivers", {}, {}),
                    reviewFees: route("review", {}, {}),
                  },
                ),
                lateOffsets: route(
                  "late-offsets/:feeChargeEventId/:adjustmentFundFamilyEventId",
                  {
                    feeChargeEventId: stringParser,
                    adjustmentFundFamilyEventId: stringParser,
                  },
                  {
                    applyOffsets: route("offsets", {}, {}),
                    reviewFees: route("review", {}, {}),
                  },
                ),
              },
            ),
            configuration: route(
              "configuration",
              {},
              {
                index: route("", {}, {}),
                calculations: route(
                  "calculations",
                  {},
                  {
                    index: route("", {}, {}),
                    create: route("create", {}, {}),
                    edit: route(
                      ":transactionCalculationId",
                      {
                        transactionCalculationId: stringParser,
                      },
                      {},
                    ),
                  },
                ),
                transactionCodes: route(
                  "transaction-codes",
                  {},
                  {
                    transactionCodesIndex: route("", {}, {}),
                    transactionCodesEdit: route("edit", {}, {}),
                  },
                ),
                classes: route(
                  "classes",
                  {},
                  {
                    index: route("", {}, {}),
                    edit: route(
                      ":investorClassId",
                      {
                        investorClassId: stringParser,
                      },
                      {
                        basic: route("", {}, {}),
                        fees: route("fees", {}, {}),
                        waterfall: route("waterfall", {}, {}),
                        commitments: route("commitments", {}, {}),
                      },
                    ),
                    fee: route(
                      ":investorClassId/fees/:feeId",
                      {
                        investorClassId: stringParser,
                        feeId: stringParser,
                      },
                      {},
                    ),
                    feeOverride: route(
                      ":investorClassId/fees/:feeId/override",
                      {
                        investorClassId: stringParser,
                        feeId: stringParser,
                      },
                      {},
                    ),
                  },
                ),
                fund: route(
                  "fund",
                  {},
                  {
                    basic: route("", {}, {}),
                    dates: route("dates", {}, {}),
                    feesList: route("fees", {}, {}),
                    waterfall: route("waterfall", {}, {}),
                    classes: route("classes", {}, {}),
                    fees: route(
                      "fees",
                      {},
                      {
                        add: route("add", {}, {}),
                        view: route(
                          ":feeId",
                          {
                            feeId: stringParser,
                          },
                          {},
                        ),
                        edit: route(
                          "edit/:feeId",
                          {
                            feeId: stringParser,
                          },
                          {},
                        ),
                      },
                    ),
                    basisEdit: route(
                      "fee-basis/:feeBasisId",
                      {
                        feeBasisId: stringParser,
                      },
                      {},
                    ),
                    classesEdit: route(
                      "classes/:investorClassId",
                      {
                        investorClassId: stringParser,
                      },
                      {
                        basic: route("", {}, {}),
                        fees: route("fees", {}, {}),
                        waterfall: route("waterfall", {}, {}),
                        commitments: route("commitments", {}, {}),
                      },
                    ),
                    classesFee: route(
                      "classes/:investorClassId/fees/:feeId",
                      {
                        investorClassId: stringParser,
                        feeId: stringParser,
                      },
                      {},
                    ),
                    classesFeeOverride: route(
                      "classes/:investorClassId/fees/:feeId/override",
                      {
                        investorClassId: stringParser,
                        feeId: stringParser,
                      },
                      {},
                    ),
                  },
                ),
                fundStructure: route(
                  "structure",
                  {},
                  {
                    allocations: route("", {}, {}),
                    fundFamilyConfigurationAllocationRuleGraphCreate: route(
                      "rule/create",
                      {},
                      {},
                    ),
                    fundFamilyConfigurationAllocationRuleGraphAndUse: route(
                      "rule/:allocationRuleGraphId/use/:allocationRuleGraphUseId",
                      {
                        allocationRuleGraphId: stringParser,
                        allocationRuleGraphUseId: stringParser,
                      },
                      {
                        ruleGraphAndUseDetails: route(
                          "rule-graph-use-details",
                          {},
                          {},
                        ),
                        basis: route("basis", {}, {}),
                      },
                    ),
                    fundFamilyConfigurationAllocationRuleGraph: route(
                      "rule/:allocationRuleGraphId",
                      {
                        allocationRuleGraphId: stringParser,
                      },
                      {
                        ruleGraphDetails: route("rule-graph-details", {}, {}),
                        ruleGraphBasis: route("rule-graph-basis", {}, {}),
                      },
                    ),
                  },
                ),
                entities: route(
                  "entities",
                  {},
                  {
                    list: route("", {}, {}),
                    entity: route(
                      ":entityId",
                      {
                        entityId: stringParser,
                      },
                      {
                        details: route("", {}, {}),
                      },
                    ),
                    createEntity: route("create", {}, {}),
                  },
                ),
                notices: route(
                  "notices",
                  {},
                  {
                    setupNoticesSchema: route("", {}, {}),
                    setupNoticesConfig: route("config", {}, {}),
                    setupNoticesCapitalCall: route("capital-call", {}, {}),
                    setupNoticesDistribution: route("distribution", {}, {}),
                  },
                ),
                creditFacilities: route(
                  "credit-facility",
                  {},
                  {
                    index: route("", {}, {}),
                    creditFacility: route(
                      ":creditFacilityId",
                      {
                        creditFacilityId: stringParser,
                      },
                      {
                        details: route("", {}, {}),
                        loan: route("loans", {}, {}),
                        settingsBorrowingBase: route("borrowing-base", {}, {}),
                      },
                    ),
                    creditFacilitySettingsBorrowingBaseEdit: route(
                      ":creditFacilityId/borrowing-base/:borrowingBaseGroupId",
                      {
                        creditFacilityId: stringParser,
                        borrowingBaseGroupId: stringParser,
                      },
                      {},
                    ),
                    creditFacilityLoanVersionPage: route(
                      ":creditFacilityId/loans/:loanId",
                      {
                        creditFacilityId: stringParser,
                        loanId: stringParser,
                      },
                      {},
                    ),
                    creditFacilityLoanCreate: route(
                      ":creditFacilityId/loans/new",
                      {
                        creditFacilityId: stringParser,
                      },
                      {},
                    ),
                  },
                ),
                investorEntities: route(
                  "investor-entities",
                  {},
                  {
                    investorEntity: route(
                      ":investorEntityId",
                      {
                        investorEntityId: stringParser,
                      },
                      {
                        tabActivity: route("activity", {}, {}),
                        tabProfile: route("profile", {}, {}),
                        tabCommitments: route("commitments", {}, {}),
                        tabPerformance: route("performance", {}, {}),
                      },
                    ),
                    commitments: route(
                      ":investorEntityId/commitments",
                      {
                        investorEntityId: stringParser,
                      },
                      {
                        fee: route(
                          ":commitmentId/fees/:feeId",
                          {
                            commitmentId: stringParser,
                            feeId: stringParser,
                          },
                          {},
                        ),
                        feeOverride: route(
                          ":commitmentId/fees/:feeId/override",
                          {
                            commitmentId: stringParser,
                            feeId: stringParser,
                          },
                          {},
                        ),
                        commitment: route(
                          ":commitmentId",
                          {
                            commitmentId: stringParser,
                          },
                          {
                            activity: route("activity", {}, {}),
                            profile: route("profile", {}, {}),
                            fees: route("fees", {}, {}),
                            waterfall: route("waterfall", {}, {}),
                            performance: route("performance", {}, {}),
                          },
                        ),
                        cancelCorrect: route(
                          "cancel-correct/:commitmentId/:fundFamilyEventId",
                          {
                            commitmentId: stringParser,
                            fundFamilyEventId: stringParser,
                          },
                          {
                            class: route("", {}, {}),
                            feeTrueUp: route("fee-true-up", {}, {}),
                            equalization: route("equalization", {}, {}),
                          },
                        ),
                        cancelCorrectHistorical: route(
                          "cancel-correct/:commitmentId/:fundFamilyEventId/historical",
                          {
                            commitmentId: stringParser,
                            fundFamilyEventId: stringParser,
                          },
                          {},
                        ),
                      },
                    ),
                  },
                ),
              },
            ),
            setup: route(
              "setup",
              {},
              {
                index: route("", {}, {}),
                profile: route("profile", {}, {}),
                dates: route("dates", {}, {}),
                entities: route("entities", {}, {}),
                transactions: route("transactions", {}, {}),
                calculations: route("calculations", {}, {}),
                classes: route("classes", {}, {}),
                fees: route(
                  "fees",
                  {},
                  {
                    index: route("", {}, {}),
                    configuration: route("configuration", {}, {}),
                    create: route("create", {}, {}),
                    edit: route(
                      "edit/:feeId",
                      {
                        feeId: stringParser,
                      },
                      {},
                    ),
                  },
                ),
                waterfalls: route("waterfalls", {}, {}),
              },
            ),
            investments: route(
              "investments",
              {},
              {
                investmentIndex: route("", {}, {}),
                investment: route(
                  ":investmentId",
                  {
                    investmentId: stringParser,
                  },
                  {
                    activity: route("activity", {}, {}),
                    setupProfile: route("", {}, {}),
                  },
                ),
                create: route("create", {}, {}),
              },
            ),
            portfolios: route(
              "portfolios",
              {},
              {
                portfolio: route(
                  ":portfolioId",
                  {
                    portfolioId: stringParser,
                  },
                  {
                    activity: route("activity", {}, {}),
                    profile: route("", {}, {}),
                    investments: route("investments", {}, {}),
                  },
                ),
              },
            ),
            financialReporting: route(
              "financial-reporting",
              {},
              {
                index: route("", {}, {}),
                hypoCreate: route(
                  "hypo/create/:type",
                  {
                    type: stringParser,
                  },
                  {},
                ),
                hypoCreateWorkflow: route(
                  "hypo/create-workflow/:type",
                  {
                    type: stringParser,
                  },
                  {
                    input: route("input", {}, {}),
                    designateProtectedCarry: route(
                      "designate-protected-carry",
                      {},
                      {},
                    ),
                    review: route("review", {}, {}),
                  },
                ),
                hypoWaterfallEdit: route(
                  ":endOfPeriodReportId/edit",
                  {
                    endOfPeriodReportId: stringParser,
                  },
                  {},
                ),
                hypotheticalWaterfall: route(
                  ":endOfPeriodReportId/hypothetical-waterfall/:hypotheticalWaterfallId",
                  {
                    endOfPeriodReportId: stringParser,
                    hypotheticalWaterfallId: stringParser,
                  },
                  {
                    irr: route("performance/irr", {}, {}),
                    prefBreakdown: route(
                      "waterfall-details/:waterfallTierMappingId/fund/:fundEntityId/pref-breakdown",
                      {
                        waterfallTierMappingId: stringParser,
                        fundEntityId: stringParser,
                      },
                      {},
                    ),
                    investorPrefBreakdown: route(
                      "waterfall-details/:waterfallTierMappingId/fund/:fundEntityId/investor-entity/:investorEntityId/pref-breakdown",
                      {
                        waterfallTierMappingId: stringParser,
                        fundEntityId: stringParser,
                        investorEntityId: stringParser,
                      },
                      {},
                    ),
                    designateProtectedCarry: route(
                      "designate-protected-carry",
                      {},
                      {},
                    ),
                    review: route(
                      "review",
                      {},
                      {
                        investorNav: route("investor-nav", {}, {}),
                        waterfallDetails: route("waterfall-details", {}, {}),
                        performance: route("performance", {}, {}),
                      },
                    ),
                  },
                ),
              },
            ),
            notFound: route("", {}, {}),
          },
        ),
      },
    ),
    generalLedger: route(
      "general-ledger",
      {},
      {
        glIntegrationList: route("", {}, {}),
        glIntegration: route(
          ":integrationId",
          {
            integrationId: stringParser,
          },
          {
            index: route("", {}, {}),
            profile: route("profile", {}, {}),
            entries: route("entries", {}, {}),
          },
        ),
      },
    ),
    reports: route(
      "reports",
      {},
      {
        availableReportsList: route("", {}, {}),
      },
    ),
    settings: route(
      "settings",
      {},
      {
        users: route("", {}, {}),
      },
    ),
    entities: route(
      "entities",
      {},
      {
        list: route("", {}, {}),
        bulkAddBanks: route("bulk-add-banks", {}, {}),
        bulkAddContacts: route("bulk-add-contacts", {}, {}),
        entity: route(
          ":entityId",
          {
            entityId: stringParser,
          },
          {
            details: route("", {}, {}),
          },
        ),
      },
    ),
    transactions: route(
      "transactions",
      {},
      {
        tableDraft: route("", {}, {}),
        tableDetails: route(
          ":viewId/details",
          {
            viewId: stringParser,
          },
          {},
        ),
      },
    ),
    investorEntities: route(
      "investor-entities",
      {},
      {
        investorEntity: route(
          ":investorEntityId",
          {
            investorEntityId: stringParser,
          },
          {
            tabActivity: route("activity", {}, {}),
            tabProfile: route("profile", {}, {}),
            tabCommitments: route("commitments", {}, {}),
            tabPerformance: route("performance", {}, {}),
          },
        ),
        commitments: route(
          ":investorEntityId/commitments",
          {
            investorEntityId: stringParser,
          },
          {
            fee: route(
              ":commitmentId/fees/:feeId",
              {
                commitmentId: stringParser,
                feeId: stringParser,
              },
              {},
            ),
            feeOverride: route(
              ":commitmentId/fees/:feeId/override",
              {
                commitmentId: stringParser,
                feeId: stringParser,
              },
              {},
            ),
            commitment: route(
              ":commitmentId",
              {
                commitmentId: stringParser,
              },
              {
                activity: route("activity", {}, {}),
                profile: route("profile", {}, {}),
                fees: route("fees", {}, {}),
                waterfall: route("waterfall", {}, {}),
                performance: route("performance", {}, {}),
              },
            ),
            cancelCorrect: route(
              "cancel-correct/:commitmentId/:fundFamilyEventId",
              {
                commitmentId: stringParser,
                fundFamilyEventId: stringParser,
              },
              {
                class: route("", {}, {}),
                feeTrueUp: route("fee-true-up", {}, {}),
                equalization: route("equalization", {}, {}),
              },
            ),
            cancelCorrectHistorical: route(
              "cancel-correct/:commitmentId/:fundFamilyEventId/historical",
              {
                commitmentId: stringParser,
                fundFamilyEventId: stringParser,
              },
              {},
            ),
          },
        ),
      },
    ),
    internal: route(
      "internal",
      {},
      {
        auditing: route("auditing", {}, {}),
        featureFlags: route("feature-flags", {}, {}),
        featureFlag: route(
          "feature-flags/:featureFlagId",
          {
            featureFlagId: stringParser,
          },
          {
            details: route("details", {}, {}),
            edit: route("edit", {}, {}),
          },
        ),
        provisioning: route(
          "provisioning",
          {},
          {
            customersTab: route("customers", {}, {}),
            usersTab: route("users", {}, {}),
            shadowTab: route("shadow", {}, {}),
          },
        ),
        customer: route(
          "provisioning/:customerId/customer",
          {
            customerId: stringParser,
          },
          {},
        ),
        shadowDataRun: route(
          "provisioning/:dataRunId/shadowDataRun",
          {
            dataRunId: stringParser,
          },
          {},
        ),
        eventing: route(
          "eventing",
          {},
          {
            templateImportTab: route("imports", {}, {}),
            templateLoadTab: route("loads", {}, {}),
            templateExportTab: route("exports", {}, {}),
          },
        ),
        eventTemplate: route(
          "eventing/:templateVersionId/template",
          {
            templateVersionId: stringParser,
          },
          {
            template: route("", {}, {}),
            templateExport: route(
              ":templateImportExportId/export",
              {
                templateImportExportId: stringParser,
              },
              {
                exportTemplateTab: route("template", {}, {}),
                exportEventsTab: route("events", {}, {}),
              },
            ),
            templateLoad: route(
              ":templateImportExportId/load",
              {
                templateImportExportId: stringParser,
              },
              {},
            ),
            templateEvent: route(
              ":templateEventId/event/:viewOrEdit",
              {
                templateEventId: stringParser,
                viewOrEdit: stringParser,
              },
              {},
            ),
            templateExportRecord: route(
              ":templateExportRecordId/record",
              {
                templateExportRecordId: stringParser,
              },
              {},
            ),
          },
        ),
        integrationTesting: route(
          "integration-testing",
          {},
          {
            activity: route("", {}, {}),
            configurations: route("configurations", {}, {}),
            report: route(
              ":integrationTestingReportId/report",
              {
                integrationTestingReportId: stringParser,
              },
              {
                reportStats: route("stats", {}, {}),
                reportTransactions: route("transactions", {}, {}),
                reportApi: route("api", {}, {}),
                reportEventing: route("eventing", {}, {}),
                reportAllTests: route("all-tests", {}, {}),
                reportChanges: route("changes", {}, {}),
                reportIssues: route("issues", {}, {}),
                reportCustomers: route("customers", {}, {}),
                reportDebuggingGuide: route("debugging-guide", {}, {}),
              },
            ),
            reportUpdate: route(
              ":integrationTestingReportId/update",
              {
                integrationTestingReportId: stringParser,
              },
              {},
            ),
            individualReport: route(
              ":integrationTestingReportId/report/:integrationIndividualTestingReportId/individual-report",
              {
                integrationTestingReportId: stringParser,
                integrationIndividualTestingReportId: stringParser,
              },
              {},
            ),
            configuration: route(
              "configurations/:integrationTestingConfigurationId",
              {
                integrationTestingConfigurationId: stringParser,
              },
              {},
            ),
          },
        ),
      },
    ),
    investors: route(
      "investors",
      {},
      {
        index: route("", {}, {}),
        investor: route(
          ":investorId",
          {
            investorId: stringParser,
          },
          {
            index: route("", {}, {}),
            activity: route("activity", {}, {}),
            profile: route("profile", {}, {}),
            funds: route("funds", {}, {}),
            performance: route("performance", {}, {}),
            entitiesList: route("investor-entities", {}, {}),
            entities: route(
              "investor-entities",
              {},
              {
                investorEntity: route(
                  ":investorEntityId",
                  {
                    investorEntityId: stringParser,
                  },
                  {
                    tabActivity: route("activity", {}, {}),
                    tabProfile: route("profile", {}, {}),
                    tabCommitments: route("commitments", {}, {}),
                    tabPerformance: route("performance", {}, {}),
                  },
                ),
                commitments: route(
                  ":investorEntityId/commitments",
                  {
                    investorEntityId: stringParser,
                  },
                  {
                    fee: route(
                      ":commitmentId/fees/:feeId",
                      {
                        commitmentId: stringParser,
                        feeId: stringParser,
                      },
                      {},
                    ),
                    feeOverride: route(
                      ":commitmentId/fees/:feeId/override",
                      {
                        commitmentId: stringParser,
                        feeId: stringParser,
                      },
                      {},
                    ),
                    commitment: route(
                      ":commitmentId",
                      {
                        commitmentId: stringParser,
                      },
                      {
                        activity: route("activity", {}, {}),
                        profile: route("profile", {}, {}),
                        fees: route("fees", {}, {}),
                        waterfall: route("waterfall", {}, {}),
                        performance: route("performance", {}, {}),
                      },
                    ),
                    cancelCorrect: route(
                      "cancel-correct/:commitmentId/:fundFamilyEventId",
                      {
                        commitmentId: stringParser,
                        fundFamilyEventId: stringParser,
                      },
                      {
                        class: route("", {}, {}),
                        feeTrueUp: route("fee-true-up", {}, {}),
                        equalization: route("equalization", {}, {}),
                      },
                    ),
                    cancelCorrectHistorical: route(
                      "cancel-correct/:commitmentId/:fundFamilyEventId/historical",
                      {
                        commitmentId: stringParser,
                        fundFamilyEventId: stringParser,
                      },
                      {},
                    ),
                  },
                ),
              },
            ),
          },
        ),
      },
    ),
    protectedNotFound: route("", {}, {}),
    notFound: route("", {}, {}),
  },
);
